/*
  Відкриття бургер-меню з будь-якого місця сторінки.

  Елемент із [data-open-nav] клікає рідний тригер шапки замість того, щоб
  самому чіпати drawer: уся логіка теми (overlay, aria-expanded, tabindex,
  блокування скролу) живе в DrawerNavSection і лишається єдиною.

  Делегування на document — кнопка може приїхати з будь-якою секцією,
  зокрема перерендереною в кастомайзері.
*/

(function () {
  'use strict';

  const TRIGGER = '.wt-header__menu-trigger';

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-nav]');
    if (!opener) return;

    // У шапці кілька тригерів під різні розкладки — беремо видимий
    const triggers = Array.from(document.querySelectorAll(TRIGGER));
    const trigger = triggers.find((el) => el.offsetParent !== null) || triggers[0];
    if (!trigger) return;

    event.preventDefault();
    trigger.click();
  });
})();
